/**
 * 这次点击会让当前标签页换页：新标签、下载、邮件链接和页内锚点都不算。
 * 只看点击本身，拦不住店面脚本事后取消跳转，所以用到它的地方都要能自己复位。
 */
export function leavesPage(event: MouseEvent): boolean {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return false;
  const anchor = event
    .composedPath()
    .find(
      (node): node is HTMLAnchorElement =>
        node instanceof HTMLAnchorElement && node.hasAttribute("href"),
    );
  if (
    !anchor ||
    anchor.hasAttribute("download") ||
    (anchor.target !== "" && anchor.target !== "_self")
  )
    return false;
  const url = new URL(anchor.href);
  if (url.protocol !== "http:" && url.protocol !== "https:") return false;
  // 带 # 且只差锚点是页内跳转，不换页；不带 # 的同一地址会重新加载，算换页。
  const here = new URL(location.href);
  return !(
    anchor.href.includes("#") &&
    url.origin === here.origin &&
    url.pathname === here.pathname &&
    url.search === here.search
  );
}
